import React, { useEffect, useState } from 'react';

import {
    FaMobileAlt
} from 'react-icons/fa';

import app from '../assets/images/app.png';

import {
    webDetails,
    FILE_BASE_URL
} from '../api/api';

function AppDownload() {

    const [webData, setWebData] = useState(null);

    useEffect(() => {

        webDetails()
            .then((res) => {
                setWebData(res.data.data);
            })
            .catch((err) => {
                console.log(err);
            });

    }, []);

    const getQrUrl = (qrPath) => {

        if (!qrPath) {
            return "";
        }

        return `${FILE_BASE_URL}${qrPath.replace(/^\/+/, "")}`;
    };

    const copyLink = async (link) => {

        if (!link) {
            return;
        }

        try {

            await navigator.clipboard.writeText(link);

            alert("App link copied!");

        } catch (error) {

            console.log("Copy failed:", error);

        }

    };

    return (
        <>

            <div className="container">

                <div className="app-download-section">

                    <div className="overlay_all"></div>

                    <div className="row align-items-center">

                        {/* Left Content */}
                        <div className="col-lg-6 content-left bg-transparent">

                            <div className="app-badge">

                                <FaMobileAlt />

                                Get the App

                            </div>

                            <h2>
                                Paar App <span>Available Now</span>
                            </h2>

                            <p>
                                Experience the best local business directory on your mobile device.
                                Discover, review, and connect with businesses anytime, anywhere.
                            </p>

                            {/* Download Section */}
                            <div className="download-section">

                                <h6>
                                    Download Now
                                </h6>

                                <div className="apklinksall">

                                    <div className="qr-download-list">

                                        {/* Business APK */}
                                        {webData?.vendor_apk_qr && (
                                            <div className="qrimageall">

                                                <span className="qr-name">
                                                    Business Apk
                                                </span>

                                                <a
                                                    href={webData?.vendor_apk_link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >

                                                    <img
                                                        src={getQrUrl(
                                                            webData.vendor_apk_qr
                                                        )}
                                                        alt="Business APK QR"
                                                    />

                                                </a>

                                                <button
                                                    type="button"
                                                    className="qr-copy-btn"
                                                    onClick={() =>
                                                        copyLink(
                                                            webData?.vendor_apk_link
                                                        )
                                                    }
                                                >
                                                    Copy Link
                                                </button>

                                            </div>
                                        )}

                                        {/* Android APK */}
                                        {webData?.android_apk_qr && (
                                            <div className="qrimageall">

                                                <span className="qr-name">
                                                    Android Apk
                                                </span>

                                                <a
                                                    href={webData?.android_apk_link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >

                                                    <img
                                                        src={getQrUrl(
                                                            webData.android_apk_qr
                                                        )}
                                                        alt="Android APK QR"
                                                    />

                                                </a>

                                                <button
                                                    type="button"
                                                    className="qr-copy-btn"
                                                    onClick={() =>
                                                        copyLink(
                                                            webData?.android_apk_link
                                                        )
                                                    }
                                                >
                                                    Copy Link
                                                </button>

                                            </div>
                                        )}

                                        {/* iOS APK */}
                                        {webData?.ios_apk_qr && (
                                            <div className="qrimageall">

                                                <span className="qr-name">
                                                    iOS Apk
                                                </span>

                                                <a
                                                    href={webData?.ios_apk_link?.trim()}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >

                                                    <img
                                                        src={getQrUrl(
                                                            webData.ios_apk_qr
                                                        )}
                                                        alt="iOS APK QR"
                                                    />

                                                </a>

                                                <button
                                                    type="button"
                                                    className="qr-copy-btn"
                                                    onClick={() =>
                                                        copyLink(
                                                            webData?.ios_apk_link?.trim()
                                                        )
                                                    }
                                                >
                                                    Copy Link
                                                </button>

                                            </div>
                                        )}

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* Right Content */}
                        <div className="col-lg-6 text-center mobile-mockup">

                            <div className="phone-frame">

                                <div className="phone-screen">

                                    <img
                                        src={app}
                                        alt="App Screenshot"
                                    />

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>
    );
}

export default AppDownload;